module.exports = __webpack_public_path__ + "img/teleconsultation.0a246e3e.png";